import * as Yup from "yup";

export const sessionFormSchema = Yup.object().shape({
  no_of_sessions: Yup.number().required("Sessions are required"),
  reason: Yup.string().required("Reason is required"),
});
